import { Icon, Color } from '@bb/elements-web';
import { Text } from 'components';
import React from 'react';
import styled from 'styled-components';

type FormStatus = 'error' | 'info';

const FORM_STATUS_STYLES: Record<
  FormStatus,
  {
    color: string;
    background: string;
    border: string;
    icon: Pick<Parameters<typeof Icon>[0], 'icon' | 'color'>;
  }
> = {
  error: {
    color: Color.DODORIA,
    background: '#FFF2F0', // TODO: convert to constant
    border: '#FFCCC7', // TODO: convert to constant
    icon: { icon: 'closeFilled', color: 'danger' },
  },
  info: {
    color: Color.ROSHI,
    background: '#E6F3FF', // TODO: convert to constant
    border: '#91C3FF', // TODO: convert to constant
    icon: { icon: 'infoCircleFilled', color: 'primary' },
  },
};

const FormStatusContainer = styled.div<{ status: FormStatus }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  color: ${props => FORM_STATUS_STYLES[props.status].color};
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: ${props => FORM_STATUS_STYLES[props.status].border};
  background-color: ${props => FORM_STATUS_STYLES[props.status].background};
`;

export const FormStatus = ({
  status,
  text,
  ...props
}: {
  status: FormStatus;
  text: string;
}) => {
  if (!text) return null;
  const {
    icon: { icon, color },
  } = FORM_STATUS_STYLES[status];
  return (
    <FormStatusContainer {...props} status={status}>
      <Icon icon={icon} size={16} color={color} />
      <Text>{text}</Text>
    </FormStatusContainer>
  );
};
